import React from 'react';
import { DisputeReviewQueryResponse } from '@pay-bill/graphql';
import { Space } from 'antd';
import { Col } from '@common/components';
import {
  DisputeViewDrawerButton,
  PerformDisputeActionButton,
} from '@pay-bill/components';

export const DisputeReviewDrawerFooter = ({
  dispute,
  onClose,
}: {
  dispute: DisputeReviewQueryResponse['dispute'];
  onClose: () => void;
}) => {
  return (
    <Space>
      {dispute.canRetract.value && (
        <div onClick={onClose}>
          <PerformDisputeActionButton
            state="retract"
            text="Retract"
            disputeId={dispute.id}
          />
        </div>
      )}
      {dispute.canReopen.value && (
        <Col span={9}>
          <DisputeViewDrawerButton action="reopen" disputeCode={dispute.code} />
        </Col>
      )}
      {dispute.canReject.value && (
        <Col span={9}>
          <DisputeViewDrawerButton action="reject" disputeCode={dispute.code} />
        </Col>
      )}
      {dispute.canRetractRedirect.value && (
        <PerformDisputeActionButton
          state="retract_redirect"
          text="Retract Forwarding"
          disputeId={dispute.id}
        />
      )}
      {dispute.canEdit.value && (
        <DisputeViewDrawerButton action="edit" disputeCode={dispute.code} />
      )}
      {dispute.canRedirectToOrganization.value && (
        <DisputeViewDrawerButton
          action="redirect"
          disputeCode={dispute.code}
          label="Send to Organization"
        />
      )}
      {dispute.canRedirectToSupplier.value && (
        <DisputeViewDrawerButton
          action="redirect"
          disputeCode={dispute.code}
          label="Send to Supplier"
        />
      )}
      {dispute.canAccept.value && (
        <DisputeViewDrawerButton
          action="accept"
          disputeCode={dispute.code}
          label="Accept"
        />
      )}
      {dispute.canApprove.value && (
        <DisputeViewDrawerButton
          action="approve"
          disputeCode={dispute.code}
          label="Approve"
        />
      )}
    </Space>
  );
};
